import { observer } from 'mobx-react';
import { ReactNode } from 'react';
import { T, TPlainTextKey } from '../../../../Translations';
import ClickableTooltip from '../../../ClickableTooltip';
import TooltipIcon from '../../../Cutesies/TooltipIcon';

interface Props {
  title: TPlainTextKey;
  children: ReactNode;
}

function TooltippedTitle({ title, children }: Props) {
  return (
    <div className="flex items-center pb-5">
      <div className="font-semibold">
        <T kind={title} />
      </div>
      <ClickableTooltip tooltipId={'license-insights'} tooltipIcon={<TooltipIcon />}>
        <>{children}</>
      </ClickableTooltip>
    </div>
  );
}

export default observer(TooltippedTitle);
